import React from 'react';
import { NoInternet } from '../../components/NoInternet';

export type MinimalLayoutType = {
  children: React.ReactNode;
};

/**
 * Minimal layout wrapper for authentication pages
 * Reduces bundle size by avoiding full layout components
 * NoInternet component handles network status monitoring internally
 */
const MinimalLayout: React.FC<MinimalLayoutType> = ({ children }) => {
  return <NoInternet>{children}</NoInternet>;
};

export default MinimalLayout;
